import React from 'react'
import { STATUS } from './utils/constants/statuses'
import { resolveUrlForArticles, careerPathToSlug } from './utils/urlUtils'
import { interpolate, getCurrentUnixTimestamp } from './utils/displayUtils'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  RequirementActions,
  ActionButton,
  ActionButtonText,
  TextButton
} from './Styles/ProgressTracker.styles'

const RequirementActionLinks = ({ displayData, requirementStatus }) => {
  const { pgaId, latestProgram } = useMembershipJourneyContext()
  const careerPath = latestProgram?.careerPath

  const hasPrimaryLink = displayData.primaryLinkText && displayData.primaryLinkUrl
  const hasSecondaryLink = displayData.secondaryLinkText && displayData.secondaryLinkUrl
  const hasActionLink = hasPrimaryLink || hasSecondaryLink
  const isActionable = requirementStatus !== STATUS.LOCKED

  if (!hasActionLink || !isActionable) {
    return null
  }

  const unixTimestamp = getCurrentUnixTimestamp()
  
  const slug = careerPathToSlug(careerPath)
  const careerPathSlug = slug ? `${slug}-` : ''
  
  const primaryUrl = resolveUrlForArticles(interpolate(displayData.primaryLinkUrl, { 
    pgaId,
    unixTimestamp,
    careerPathSlug
  }))

  const secondaryUrl = resolveUrlForArticles(interpolate(displayData.secondaryLinkUrl, {
    pgaId,
    unixTimestamp,
    careerPathSlug
  }))

  return (
    <RequirementActions>
      {hasPrimaryLink && (
        <ActionButton
          as="a"
          href={primaryUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ActionButtonText>
            {displayData.primaryLinkText}
          </ActionButtonText>
        </ActionButton>
      )}
      {hasSecondaryLink && (
        <TextButton
          as="a"
          href={secondaryUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {displayData.secondaryLinkText}
        </TextButton>
      )}
    </RequirementActions>
  )
}

export default RequirementActionLinks

